import React from "react";
import { useValidators } from "../../../helpers/validation";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { FormSubmitHandler } from "../../../common/models";
import { handleFormServerErrors } from "../../../helpers/errorHandling";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import TextInput from "../TextInput";
import FormError from "../FormError";
import Button from "../../button/Button";
import SubmitButton from "../SubmitButton";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { NavLink } from "react-router";

interface Props {
  onSubmit: FormSubmitHandler<LoginFormValues>;
  onInvitePage?: boolean;
}

export interface LoginFormValues {
  username: string;
  password: string;
}

const LoginForm: React.FC<Props> = (props): React.ReactElement => {
  const { tInput, tError } = useCustomTranslation();
  const validators = useValidators();

  const navigate = useNavigate();

  const methods = useForm<LoginFormValues>({
    defaultValues: {
      username: "",
      password: "",
    },
    mode: "onBlur",
  });

  const onSubmit: SubmitHandler<LoginFormValues> = async (data) => {
    try {
      await props.onSubmit(data);
    } catch (e) {
      handleFormServerErrors(e, tError, methods.setError);
    }
  };

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="sm:w-[480px]">
        <TextInput
          name="username"
          placeholder={tInput("email_input")}
          type="email"
          required
          options={{ required: validators.required }}
        />
        <TextInput
          name="password"
          placeholder={tInput("password_input")}
          type="password"
          required
          options={{ required: validators.required }}
        />
        <FormError />
        <div className="mt-6 flex flex-col sm:flex-row sm:justify-between">
          <Button
            label={tInput("forget_password_button")}
            onClick={() => navigate.goTo("/password")}
            className="mb-2 hidden sm:mb-0 sm:block"
          />
          <SubmitButton label={tInput("login_button")} icon="arrow-right" />
          <NavLink
            to={"/password"}
            title={tInput("forget_password_button")}
            children={tInput("forget_password_button")}
            className="mt-4 text-center text-[15px]/[24px] font-semibold sm:hidden"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default LoginForm;
